import { PAGINATION_ROWS } from 'pages/transportCloud/components/TransportCloudTable/TransportCloudTable.consts';

export const DEFAULT_PARAMS = {
  pageNumber: 1,
  resultSize: PAGINATION_ROWS[3],
  filterText: '',
  onlyMine: true,
};
